import type { Topic as TopicType } from '@/@types/topic'
import ClickWrapper from '@/components/ClickWrapper'
import clsx from 'clsx'
import { isEmpty, partial } from 'lodash-es'
import { AnimatePresence, type HTMLMotionProps, motion } from 'motion/react'
import styles from './TopicSuggestions.module.css'

export interface TopicSuggestionsProps extends Omit<HTMLMotionProps<'div'>, 'onSelect'> {
	data: TopicType[]
	onSelect?: (value: TopicType) => void
}

export default function TopicSuggestions({
	onSelect,
	data,
	className,
	...props
}: TopicSuggestionsProps) {
	return (
		<motion.div
			{...props}
			className={clsx(styles.container, !isEmpty(data) && styles.containerWithData, className)}
		>
			<AnimatePresence mode="popLayout">
				{data.map((item, index) => (
					<ClickWrapper
						initial={{
							opacity: 0,
						}}
						animate={{
							opacity: 1,
							transition: {
								delay: index * 0.05,
							},
						}}
						exit={{
							opacity: 0,
						}}
						key={item.id}
						onClick={onSelect && partial(onSelect, item)}
						className={styles.item}
					>
						{item.content}
					</ClickWrapper>
				))}
			</AnimatePresence>
		</motion.div>
	)
}
